module.exports = __webpack_public_path__ + "static/media/squirrel2.39dba52f.jpg";